import TimelineBlock from '@components/accountTimeline/accountTimelineBlock/TimelineBlock';

const NoTimeline = () => {
    return (
        <TimelineBlock
            heading="No Timeline"
            timelineItems={[
                {
                    type: 'NOTIMELINE',
                    account_id: 0,
                    category: '',
                    tenant_account_timestamp: '',
                    timestamp: '',
                    data: { item: {} },
                    correlation_id: '',
                },
            ]}
        />
    );
};

export default NoTimeline;
